import React, { useEffect} from "react";
import AppProvider  from './AppProvider';
import Routes from "./Routes";
import Loading from "./components/Loading";



import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-green/theme.css";
import "primeicons/primeicons.css";
import 'primeflex/primeflex.css';

/**
 * @summary Componente que representa  o aplicativo principal de mais alto nível.
 */
const App = () =>{
  useEffect(()=>{

  },[]);

  return (
    <div>
      <AppProvider>
        <Routes/>
        <Loading/>
      </AppProvider>
    </div>
  )
}

export default App;
